import { isEmpty } from 'lodash-es'
import { useTranslations } from 'next-intl'

import { NoSearchResult, TRoomPreview } from '@/entities/room'

import { MobileRoomItem, MobileRoomItemSkeleton } from '../room-item'

type Props = {
  isLoading: boolean
  rooms: TRoomPreview[]
  sentinelRef: (node?: Element | null) => void
}

export const MobileRoomList = ({ isLoading, rooms, sentinelRef }: Props) => {
  if (isEmpty(rooms)) {
    return <NoResultMessage />
  }

  return (
    <ul>
      {(() => {
        if (isLoading) {
          return Array.from({ length: 4 }).map((_, index) => (
            <li
              key={index}
              className="group not-last:border-b not-last:border-gray-100"
            >
              <MobileRoomItemSkeleton className="py-5 group-first:pt-0 group-last:pb-0" />
            </li>
          ))
        }

        return rooms.map((room, index) => {
          const isLastItem = index === rooms.length - 1

          return (
            <li
              key={room.rid}
              ref={isLastItem ? sentinelRef : null}
              className="group not-last:border-b not-last:border-gray-100"
            >
              <MobileRoomItem room={room} />
            </li>
          )
        })
      })()}
    </ul>
  )
}

const NoResultMessage = () => {
  const t = useTranslations('search_result')

  return (
    <div className="flex w-full shrink-0 flex-col items-center justify-center pt-25">
      <NoSearchResult className="mb-6" />
      <h3 className="typo-headline3 mb-4 text-center font-bold whitespace-break-spaces text-black">
        {t('empty_result.title')}
      </h3>
      <p className="typo-label1 text-center text-gray-900">
        {t('empty_result.description')}
      </p>
    </div>
  )
}
